enum SortingOrder {
    ascending = 'asc',
    descending = 'desc',
}

export default SortingOrder;
